import type { FC } from 'react';
import React from 'react';
import { StaticActions as actions } from '@alfa-bank/site-form-utils/actions';

import type { TFio } from './models';

const DEFAULT_MAX_LENGTH = 35;

/**
 * Поля ввода ФИО
 */
export const Fio: FC<TFio> = ({
    Fields,
    FioField,
    className,
    name,
    settings,
    validateNotEmpty,
    withGender = true,
    analytics = {},
    maxLength = DEFAULT_MAX_LENGTH,
    genderTagsSize,
    checkboxColor,
    requestDelay,
}) => {
    const { firstName, gender, lastName, middleName } = actions.getNames(name);
    const fields = [lastName, firstName, middleName];

    if (gender) fields.push(gender);

    return (
        <div className={className}>
            <Fields
                data={settings}
                dispatchesFocus
                fields={fields}
                receivesFocus
                render={(lastNameField, firstNameField, middleNameField, genderField) => (
                    <FioField
                        analytics={analytics}
                        autoComplete="nope"
                        firstName={firstNameField}
                        firstNameRef={actions.getRef(firstNameField.meta)}
                        gender={genderField}
                        genderRef={actions.getRef(genderField.meta)}
                        genderSettings={{ name: gender, size: genderTagsSize }}
                        hasMiddleNameSettings={{ color: checkboxColor }}
                        lastName={lastNameField}
                        lastNameRef={actions.getRef(lastNameField.meta)}
                        maxLength={maxLength}
                        middleName={middleNameField}
                        middleNameRef={actions.getRef(middleNameField.meta)}
                        onBlur={({ field: { input } }) => actions.onBlur(input)()}
                        onCancel={field => actions.onCancel(field)}
                        onChange={({ field: { input }, value }) => actions.onChange(input)(value)}
                        onComplete={field => actions.onComplete(field)}
                        onFocus={({ field: { input } }) => actions.onFocus(input)()}
                        onSelect={({ field, value }) => actions.onSelect(field)(value)}
                        requestDelay={requestDelay}
                        withGender={withGender}
                    />
                )}
                validate={validateNotEmpty()}
            />
        </div>
    );
};
